import { forbiddenState, homescreenState } from "./base.routes";

export function previousIfForbidden(rejectedPermission, transitionProperties) {
    let redirectState = transitionProperties.fromState.name;
    let redirectParams = transitionProperties.fromParams;
    return {
        state: forbiddenState,
        params: {
            redirect: {
                state: redirectState,
                params: redirectParams,
            },
        },
    };
}
